import { render, staticRenderFns } from "./TeacherData.vue?vue&type=template&id=02dcb274&"
import script from "./TeacherData.vue?vue&type=script&lang=js&"
export * from "./TeacherData.vue?vue&type=script&lang=js&"
import style0 from "./TeacherData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports